import * as ErpRecipeList from 'types/Recipe/Detail/ErpNew/ErpRecipeList';
import EntityType from 'types/ShoppingCart/EntityType';

export * as State from 'components/desktop/ShoppingCart/_general/AddToCartModal/State';

export type Type = {
	id: string | null;
	entityType: EntityType;
	erpRecipes?: { id: string; name: string }[];
	selectedErpRecipeId?: string;
	selectedShoppingCartId?: string;
	amount: number;
};

export function create(): Type {
	return {
		id: null,
		entityType: EntityType.RECIPE,
		amount: 1,
	};
}

export async function initialize(
	obj: Type,
	input?: {
		id: string | undefined;
		entity?: EntityType;
	}
): Promise<Type> {
	if (!input) return obj;
	if (!input.id) return obj;
	if (input.entity !== EntityType.RECIPE)
		return { ...obj, id: input.id, selectedErpRecipeId: '', erpRecipes: [] };
	const erpRecipes = await ErpRecipeList.getErpRecipesByRecipeId(input.id);
	return {
		...obj,
		id: input.id,
		selectedErpRecipeId: '',
		erpRecipes: erpRecipes.map((e) => ({ id: e.id, name: e.name })),
	};
}

export function changeAmount(obj: Type, amount: number): Type {
	return { ...obj, amount: amount };
}

export function changeSelectedErpRecipeId(obj: Type, selectedId: string): Type {
	return { ...obj, selectedErpRecipeId: selectedId };
}

export function changeSelectedShoppingCartId(obj: Type, selectedShoppingCartId: string): Type {
	return { ...obj, selectedShoppingCartId: selectedShoppingCartId };
}

export function getId(obj: Type): string | null {
	return obj.selectedErpRecipeId ? obj.selectedErpRecipeId : null;
}
